module.exports = __webpack_public_path__ + "index/img/SmartFireZh-danyang.7af322c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SmartFireZh-danyang.png
// module id = UXQ6
// module chunks = 2